module.exports = __webpack_public_path__ + "static/media/sixinarow-iphone5s-bezel-3-schedule-export.1c2d3c38.mp4";